import {
  Component,
  computed,
  inject,
  input,
  output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextButtonComponent } from '../text-button/text-button.component';
import { ExpandableComponent } from '../expandable-component/expandable.component';
import { IconNameType } from '../icons/icon-name-type.enum';
import { Coupon } from '../../core/models/core/coupon.model';
import { CouponStatus } from '../../core/models/core/coupon-status.enum';
import { LayoutService } from '../../core/services/layout.service';
import { CouponType } from '../../core/models/core/coupon-type.enum';
import { TranslocoPipe } from '@ngneat/transloco';
import { AuditService } from '../../core/services/audit.service';
import { A11yModule } from '@angular/cdk/a11y';
import { FocusService } from '../../core/services/focus.service';

@Component({
  selector: 'cwo-coupon-detail',
  standalone: true,
  imports: [
    CommonModule,
    TextButtonComponent,
    ExpandableComponent,
    TranslocoPipe,
    A11yModule
  ],
  templateUrl: './coupon-detail.component.html',
  styleUrl: './coupon-detail.component.scss',
})
export class CouponDetailComponent {
  iconNameType = IconNameType;
  expanded = false;
  layoutService = inject(LayoutService);
  private auditService = inject(AuditService);
  private focusService = inject(FocusService);
  
  index = input.required();
  coupon = input.required<Coupon>();
  loading = input.required<boolean>();
  isSelected = input<boolean>(false);
  anotherCouponLoading = input<boolean>(false);
  couponType = CouponType;

  readonly couponSelected = output<boolean>();

  disabled = computed(() => {
    return this.coupon().status === CouponStatus.NON_APPLICABLE;
  });

  handleExpandation(value: boolean) {
    this.auditService.createAudit(() => `View ${value? 'more expanded' : 'less collapsed'} on Coupon: ${this.coupon().name ?? this.coupon().code}`);
    this.expanded = value;
  }

   handleSelection(event?: Event) {
    if (event?.type === 'keydown' && event.target !== event.currentTarget) {
      return;
    }
    const target = event?.target as HTMLElement | null;
    if (target?.closest('.text-button, cwo-text-button')) {
      return;
    }
    this.focusService.savePreviousFocus();
    this.couponSelected.emit(!this.isSelected());
  }

  handleClaimClick(event: Event) {
    event.stopPropagation();
    this.focusService.savePreviousFocus();
    this.auditService.createAudit(() => `${!this.isSelected() ? 'Claim' : 'Unclaim'} button for coupon: ${this.coupon().name}, was clicked`);
    this.couponSelected.emit(!this.isSelected());
  }

  formatDate(value: string) {
    const dateObj = new Date(value);

    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const year = dateObj.getFullYear();

    return `${month}/${day}/${year}`;
  }
}
